import * as React from 'react'
import { countries } from '@abx/country-data'

class MdCountrySelect extends React.Component<MdCountrySelectProps, null> {

  constructor(props: any) {
    super(props)
  }

  public render() {
    return (
      <select
        value={this.props.selectedCountry}
        onChange={(e) => this.props.onSelectCountry(e.target.value)}
        >
        {countries.all.map((country, id) => {
          return <option
                    key={id}
                    value={country.name}
                    >
                    {country.name}
                  </option>
        })}
      </select>
    )
  }
}

export default MdCountrySelect



// WEBPACK FOOTER //
// ./react/components/widgets/MdCountrySelect.tsx